import { render } from "./devDashLogin.vue?vue&type=template&id=3610ea03"
import script from "./devDashLogin.vue?vue&type=script&lang=js"
export * from "./devDashLogin.vue?vue&type=script&lang=js"

import "./devDashLogin.vue?vue&type=style&index=0&id=3610ea03&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__